import { fetchApi } from '../api/digitalVault';
import { parsePlaylists } from '../utils';
import { getUserPlaylistItems } from '.';
const getUserPlaylistById = async (id, params = {}, logger) => {
    const rawResponse = await fetchApi({}, `playlist/${id}`, {}, false, logger);
    const [playlist] = await parsePlaylists(rawResponse.playlistDefinition, false);
    const playlistItems = await getUserPlaylistItems(id, params);
    return {
        ...playlistItems,
        collectionName: playlist.name,
        mediaItemsCount: playlist.validItemsCount,
    };
};
export default getUserPlaylistById;
